import { faChevronRight, faTimes } from '@fortawesome/free-solid-svg-icons';
import { faMinusSquare, faPlusSquare } from '@fortawesome/pro-regular-svg-icons';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, IconButton, Modal, Typography, useMediaQuery } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';
import { getBenef } from '../../../Store/storages/BeneficiarioStorage';
import TypographyAccessibility from '../../../components/Accessibility/TypographyAccessibility';
import FilterSelect from '../../../components/FilterSelect';
import IOSSwitch from '../../../components/IosSwitch';
import LoadingApp from '../../../components/LoadingApp';
import ModalFeedBack from '../../../components/ModalFeedBack';
import { Carteirinha } from '../../../interfaces/entities/Carteirinha';
import { FilterInterface } from '../../../interfaces/entities/FilterInterface';
import { TokenUnimed } from '../../../interfaces/entities/TokenUnimed';
import { getCarteirinha, getTokenUnimed } from '../../../services/BeneficiarioService';
import CardBack from './CardBack';
import CardFront from './CardFront';
import './styles.css';
import { sxBeneficiarioMoreInfo, sxBeneficiarioMoreInfoLabel, sxInfoBeneficiario, sxInfoNoCard, sxLabelInfoBeneficiario, sxQrCodeButton, sxSubTitleQrCode, sxTextButtonQr, sxTextSwitch, sxTitleQrCode, sxTokenQrCode, sxTypographyTitle } from './sxProps';
import PageTitle from '../../../components/Accessibility/PageTitle';
import DefaultButton from '../../../components/Accessibility/DefaultButton';

const CartaoVirtual: React.FC = () => {

  const accessibility = useAccessibility();

  const [listOptionsBeneficiarios, setListOptionsBeneficiarios] = useState<Array<FilterInterface>>([]);
  const [listBeneficiarios, setListBeneficiarios] = useState<Array<Carteirinha>>([]);
  const [selectedBeneficiarios, setSelectedBeneficiarios] = useState<string>();
  const [showLoading, setShowLoading] = useState<boolean>(true);
  const [showModalFeedBack, setShowModalFeedBack] = useState<boolean>(false);
  const [finishLoad, setFinishLoad] = useState<boolean>(false);
  const [showModalQrCode, setShowModalQrCode] = useState<boolean>(false);
  const [tokenUnimed, setTokenUnimed] = useState<TokenUnimed>();
  const [showBack, setShowBack] = useState(false);
  const [timeOutQrCode, setTimeOutQrCode] = useState(0);
  const [showMoreInformation, setShowMoreInformation] = useState<boolean>(false);
  const isDesktop = useMediaQuery('(min-width: 1200px)');
  const hours = Math.floor(timeOutQrCode / 3600);
  const minutes = Math.floor((timeOutQrCode % 3600) / 60);
  const seconds = timeOutQrCode % 60;

  useEffect(() => {
    if (!finishLoad)
      getBeneficiarios();

    const intervalId = setInterval(() => {
      setTimeOutQrCode(prevTempo => prevTempo - 1);
    }, 1000);

    if (timeOutQrCode === 1) {
      getQrCode()
    }

    return () => clearInterval(intervalId);
  }, [timeOutQrCode]);

  const handleBeneficiario = (value: string) => {
    setSelectedBeneficiarios(value)
  };

  const toggleShowMoreInformation = () => {
    setShowMoreInformation(showInfo => !showInfo);
  }

  const getBeneficiarios = async () => {
    await getCarteirinha().then((response) => {
      if (response?.status === 200) {
        var data: Array<Carteirinha> = response.data;

        var optionsBeneficiarios = data.map((carteirinha: Carteirinha) => ({
          id: carteirinha.nomeBeneficiario,
          descricao: carteirinha.nomeBeneficiario
        }));

        setListBeneficiarios(data);
        setListOptionsBeneficiarios(optionsBeneficiarios);

        if (data.length > 0) {
          var benefLogado = getBenef();
          var cartaBenefLogado = data.filter((beneficiario) => beneficiario.idUsrContr === benefLogado?.idUsrContr.toString())[0]
          setSelectedBeneficiarios(cartaBenefLogado.nomeBeneficiario);
        }
      } else {
        setShowModalFeedBack(!showModalFeedBack)
      }
    });
    setShowLoading(false);
    setFinishLoad(true);
  };

  const getSelectBeneficiario = (): Carteirinha => {
    return listBeneficiarios.filter((beneficiario) => beneficiario.nomeBeneficiario === selectedBeneficiarios)[0];
  };

  const getQrCode = async () => {
    await getTokenUnimed(getSelectBeneficiario().idUsrContr).then((response) => {
      if (response?.status === 200) {
        setTokenUnimed(response?.data);

        const dtExpiracao: Date = new Date(response?.data.dtExpiracao);
        const dtServidor: Date = new Date(response?.data.dtServidor);

        const diferencaEmMilissegundos: number = dtExpiracao.getTime() - dtServidor.getTime();
        const diferencaEmSegundos: number = diferencaEmMilissegundos / 1000;

        setTimeOutQrCode(diferencaEmSegundos)
      }
    });
  };

  const openModalQrCode = async () => {
    setShowLoading(true);
    await getQrCode();

    setShowModalQrCode(true);
    setShowLoading(false);
  };

  return (
    <div className='width-100'>
      <div>
        <PageTitle text="Cartão virtual" style={{marginBottom: '20px'}} />
      </div>
      {
        !showLoading && listBeneficiarios.length === 0 ?
          <div className='container-cartao-vazio'>
            <FontAwesomeIcon size='5x' color='#00995D' icon={faExclamationCircle} />
            <Typography style={accessibility.textStyleAccessibility} sx={sxInfoNoCard}>Não foi encontrado nenhum cartão virtual válido.</Typography>
            <Typography style={accessibility.textStyleAccessibility} sx={sxInfoNoCard}>Por favor, entre em contato com a Unimed Campinas.</Typography>
          </div> :
          <>
            <div className='container-select-qrCode'>
              <div className='container-cartao-virtual-select'>
                <FilterSelect value={selectedBeneficiarios} title='Beneficiário' options={listOptionsBeneficiarios} disabled={false} handleChange={handleBeneficiario} />

              </div>
              <div className='container-btn-qrCode'>
                <DefaultButton onClick={() => openModalQrCode()} aria-label="Gerar QR code/token do cartão virtual">
                  <Typography style={accessibility.buttonTextStyleAccessibility} sx={sxTextButtonQr}>Gerar QR Code/Token</Typography>
                  <FontAwesomeIcon style={accessibility.buttonTextStyleAccessibility} icon={faChevronRight} />
                </DefaultButton>
              </div>
            </div>
          </>
      }
      {
        selectedBeneficiarios &&
        <div>
          {isDesktop ?
            <div className='container-cartao'>
              <CardFront getSelectBeneficiario={getSelectBeneficiario}
                toggleMoreInfo={toggleShowMoreInformation} showMoreInfo={showMoreInformation}
              />
              <CardBack getSelectBeneficiario={getSelectBeneficiario} showMoreInfo={showMoreInformation} />
            </div> :
            <div className='container-cartao-mobile'>
              {!showBack &&
                <div className={`rotating-button ${showBack ? '' : 'flipInY'}`}>
                  <CardFront getSelectBeneficiario={getSelectBeneficiario} showMoreInfo={showMoreInformation} />
                </div>}
              {showBack &&
                <div className={`rotating-button ${!showBack ? '' : 'flipInY'}`}>
                  <CardBack getSelectBeneficiario={getSelectBeneficiario} showMoreInfo={showMoreInformation} />
                </div>}
              <div className='container-switch-cartao'>
                <TypographyAccessibility sx={sxTextSwitch}>Frente</TypographyAccessibility>
                <IOSSwitch sx={{ m: 1 }}
                  checked={showBack}
                  onChange={() => setShowBack(!showBack)}
                  inputProps={{ 'aria-label': 'controlled' }}
                />
                <TypographyAccessibility sx={sxTextSwitch}>Verso</TypographyAccessibility>
              </div>
              <div className='more-info-container'>
                <button className="more-info-button" onClick={toggleShowMoreInformation} aria-label={`${!showMoreInformation ? 'Mais' : 'Ocultar'} informações`}>
                  <FontAwesomeIcon icon={!showMoreInformation ? faPlusSquare : faMinusSquare} className='fa-icon-plus-square' />&nbsp;&nbsp;
                  <u>{`${!showMoreInformation ? 'Mais' : 'Ocultar'} informações`}</u>
                </button>
                {showMoreInformation &&
                  <div className={`more-infos-card ${showMoreInformation ? 'openCard' : 'closeCard'}`}>
                    <div className='container-more-infos-card'>
                      <div className='more-info-card-columns'>
                        <div>
                          <Typography sx={sxBeneficiarioMoreInfo}>{getSelectBeneficiario().dtNasc}</Typography>
                          <Typography sx={sxBeneficiarioMoreInfoLabel}>Data de Nascimento</Typography>
                        </div>
                        <div>
                          <Typography sx={sxBeneficiarioMoreInfo}>{getSelectBeneficiario().coberturaParcialTemporaria}</Typography>
                          <Typography sx={sxBeneficiarioMoreInfoLabel}>Cobertura Parcial Temporária</Typography>
                        </div>
                      </div>
                      <div className='more-info-card-columns'>
                        <div>
                          <Typography sx={sxBeneficiarioMoreInfo}>{getSelectBeneficiario().vigenciaPlano}</Typography>
                          <Typography sx={sxBeneficiarioMoreInfoLabel}>Vigência do Plano</Typography>
                        </div>
                        <div>
                          <Typography sx={sxBeneficiarioMoreInfo}>{getSelectBeneficiario().via}</Typography>
                          <Typography sx={sxBeneficiarioMoreInfoLabel}>Via</Typography>
                        </div>
                      </div>
                    </div>
                    <div>
                      <Typography sx={sxBeneficiarioMoreInfo}>{getSelectBeneficiario().contratante}</Typography>
                      <Typography sx={sxBeneficiarioMoreInfoLabel}>Contratante</Typography>
                    </div>
                  </div>
                }
              </div>
              <div className='container-info-beneficiario'>
                <div className='info-beneficiario'>
                  <TypographyAccessibility sx={sxLabelInfoBeneficiario}>Nome do beneficiário:</TypographyAccessibility>
                  <TypographyAccessibility sx={sxInfoBeneficiario}>{getSelectBeneficiario().nomeBeneficiario.toLowerCase()}</TypographyAccessibility>
                </div>
                <div className='info-beneficiario'>
                  <TypographyAccessibility sx={sxLabelInfoBeneficiario}>Acomodação:</TypographyAccessibility>
                  <TypographyAccessibility sx={sxInfoBeneficiario}>{getSelectBeneficiario().acomodacao.toLowerCase()}</TypographyAccessibility>
                </div>
                <div className='info-beneficiario'>
                  <TypographyAccessibility sx={sxLabelInfoBeneficiario}>Plano:</TypographyAccessibility>
                  <TypographyAccessibility sx={sxInfoBeneficiario}>{getSelectBeneficiario().plano.toLowerCase()}</TypographyAccessibility>
                </div>
                <div className='info-beneficiario'>
                  <TypographyAccessibility sx={sxLabelInfoBeneficiario}>Vigência do plano:</TypographyAccessibility>
                  <TypographyAccessibility sx={sxInfoBeneficiario}>{getSelectBeneficiario().vigenciaPlano}</TypographyAccessibility>
                </div>
                <div className='info-beneficiario'>
                  <TypographyAccessibility sx={sxLabelInfoBeneficiario}>Abrangência:</TypographyAccessibility>
                  <TypographyAccessibility sx={sxInfoBeneficiario}>{getSelectBeneficiario().abrangencia.toLowerCase()}</TypographyAccessibility>
                </div>
                <div >
                  <TypographyAccessibility sx={sxLabelInfoBeneficiario}>Segmentação Assistencial do plano:</TypographyAccessibility>
                  <TypographyAccessibility sx={sxInfoBeneficiario}>{getSelectBeneficiario().segmentacaoAssistencialPlano.toLowerCase()}</TypographyAccessibility>
                </div>
                <div className='info-beneficiario'>
                  <TypographyAccessibility sx={sxLabelInfoBeneficiario}>Rede de Atendimento:</TypographyAccessibility>
                  <TypographyAccessibility sx={sxInfoBeneficiario}>{getSelectBeneficiario().redeDeAtendimento.toLowerCase()}</TypographyAccessibility>
                </div>
                <div className='info-beneficiario'>
                  <TypographyAccessibility sx={sxLabelInfoBeneficiario}>Atendimento:</TypographyAccessibility>
                  <TypographyAccessibility sx={sxInfoBeneficiario}>{getSelectBeneficiario().atendimento.toLowerCase()}</TypographyAccessibility>
                </div>
                <div className='info-beneficiario'>
                  <TypographyAccessibility sx={sxLabelInfoBeneficiario}>Cod. Produto ANS:</TypographyAccessibility>
                  <TypographyAccessibility sx={sxInfoBeneficiario}>{getSelectBeneficiario().codigoProduto}</TypographyAccessibility>
                </div>
                <div className='info-beneficiario'>
                  <TypographyAccessibility sx={sxLabelInfoBeneficiario}>CNS:</TypographyAccessibility>
                  <TypographyAccessibility sx={sxInfoBeneficiario}>{getSelectBeneficiario().cns.toLowerCase()}</TypographyAccessibility>
                </div>
              </div>
            </div>
          }


        </div>
      }
      <LoadingApp showLoading={showLoading} />
      <ModalFeedBack
        showModal={showModalFeedBack}
        handleButtonModal={() => setShowModalFeedBack(!showModalFeedBack)}
        showButtonModal
        textButton='Fechar'
        handleShowModal={() => setShowModalFeedBack(!showModalFeedBack)}
        icon='error'
        title='Erro ao carregar dados do contarato'
      />
      <Modal
        open={showModalQrCode}
        onClose={() => setShowModalQrCode(!showModalQrCode)}
      >
        <div className='container-modal-qrCode' style={accessibility.contrastStyle} >
          <div className='container-button-close-contract '>
            <IconButton onClick={() => setShowModalQrCode(!showModalQrCode)} style={accessibility.buttonStyleAccessibility}>
              <FontAwesomeIcon icon={faTimes} />
            </IconButton>
          </div>
          <div className='container-info-qrCode'>
            <TypographyAccessibility sx={sxTitleQrCode}>Token gerado com sucesso!</TypographyAccessibility>
            <TypographyAccessibility sx={sxSubTitleQrCode}>Apresente este token no atendimento:</TypographyAccessibility>
            <TypographyAccessibility sx={sxTokenQrCode}>{tokenUnimed?.numeroTokenUnimed}</TypographyAccessibility>
          </div>
          <div >
            <img height={'246px'} width={'246px'} src={tokenUnimed?.qrCode} alt="Qr Code" />
          </div>
          <div className='container-info-qrCode'>
            <TypographyAccessibility sx={sxSubTitleQrCode}>O código expira em:</TypographyAccessibility>
            <div className='display-flex'>
              <TypographyAccessibility sx={sxTitleQrCode}>{String(hours).padStart(2, '0')}:</TypographyAccessibility>
              <TypographyAccessibility sx={sxTitleQrCode}>{String(minutes).padStart(2, '0')}:</TypographyAccessibility>
              <TypographyAccessibility sx={sxTitleQrCode}>{String(seconds).padStart(2, '0')}</TypographyAccessibility>
            </div>
          </div>
        </div>
      </Modal>
    </div >
  )
}

export default CartaoVirtual